import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { setToken, getToken, setUnauthorizedHandler } from "./api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  const logout = useCallback(async () => {
    try { await api.logout(); } catch (e) {}
    setToken(null);
    setUser(null);
  }, []);

  useEffect(() => {
    setUnauthorizedHandler(() => setUser(null));
    const hash = window.location.hash || "";
    // Emergent Google OAuth returns to {origin}#session_id=... — exchange it first.
    if (hash.includes("session_id=")) {
      const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
      (async () => {
        try {
          const { user, accessToken } = await api.googleSession(sid);
          setToken(accessToken);
          setUser(user);
        } catch (e) { /* fall through to login screen */ }
        finally {
          window.history.replaceState(null, "", window.location.pathname + window.location.search);
          setReady(true);
        }
      })();
      return;
    }
    (async () => {
      if (getToken()) {
        try {
          const { user } = await api.me();
          setUser(user);
        } catch (e) { setToken(null); }
      }
      setReady(true);
    })();
  }, []);

  const login = async (email, password) => {
    const { user, accessToken } = await api.login({ email, password });
    setToken(accessToken);
    setUser(user);
    return user;
  };

  const register = async (payload) => {
    const { user, accessToken } = await api.register(payload);
    setToken(accessToken);
    setUser(user);
    return user;
  };

  const loginWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <AuthCtx.Provider value={{ user, ready, login, register, logout, setUser, loginWithGoogle }}>
      {children}
    </AuthCtx.Provider>
  );
}
